import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'theme/Grid';

const NotFoundPage = () => {
  return (
    <Container className='not-found'>
      <h1>Page Not Found</h1>
      <p>Whoops! Sorry,  there is nothing here.</p>
      <Link to='/'>Back to Home</Link>
    </Container>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js